module.exports = __webpack_public_path__ + "static/img/年度最佳洗碗机.9886137f.png";